import React, { type ComponentPropsWithoutRef, forwardRef } from 'react';

import { type Banner } from '../Banner';

import { Styled } from './styles';

type BannerProps = ComponentPropsWithoutRef<typeof Banner>;

type Props = BannerProps;

export const Toast = forwardRef<HTMLDivElement, Props>(({ ...props }, ref) => <Styled.Banner {...props} ref={ref} />);
Toast.displayName = 'Toast';
